/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */


const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];


export function getZeroBasedMonthLabel(index) {
  return months[index];
}


export function getOneBasedMonthLabel(index) {
  return months[index-1];
}


/**
 * Returns a javascript date for the items date values stored as strings
 * or if empty or null returns todays date or todays date and an offset in 
 * years
 *
 * Input Format is #yyyy-mm-dd
 * 
 * @param {string} dateStr 
 * @param {number} offset 
 * @returns {Date}
 */
export function cleanDate(dateStr, offset) {
  var today = new Date();

  var y = today.getFullYear();
  var m = today.getMonth();
  var d = today.getDate();

  if (dateStr.length) {
    if (dateStr[0] !== '#') {
      throw "Invalid Date missing '#'";
    }

    y = parseInt(dateStr.substr(1, 4));
    m = parseInt(dateStr.substr(6, 2)) - 1;
    d = parseInt(dateStr.substr(9, 2));
  }

  y += offset;

  var n = new Date(y, m, d);

  return n;
}


/**
* Given two dates, return the number of months between them.
 * @param {Date} dateFrom 
 * @param {Date} dateTo 
 */
export function monthDiff( dateFrom, dateTo) {
  var year_diff = 12 * (dateTo.getFullYear() - dateFrom.getFullYear() );
  var mon_diff = dateTo.getMonth() - dateFrom.getMonth();
  var day_diff = dateTo.getDate() - dateFrom.getDate();

  var diff = year_diff + mon_diff;

  if ( day_diff > 0 )
    diff++;
    
  return diff;
}
 

/**
 * Given a javascript date object, return a Paycheck Planner date formatted string
 * #yyyy-mm-dd
 * @param {Date} date
 * @returns {string} 
 */
export function formatDate(date) {
  var date_str = "";

  var dd = date.getDate();
  var mm = date.getMonth() + 1; //January is 0!
  var yyyy = date.getFullYear();

  if (dd < 10) {
    dd = '0' + dd;
  }

  if (mm < 10) {
    mm = '0' + mm;
  }

  date_str = "#" + yyyy + "-" + mm + "-" + dd + "";

  return date_str;
}


// TODO this needs to be part of i18n
/**
 * Given a Date object, return default string format dd-Mmm-yyyy
 * @param {Date} date 
 * @return {string}
 */
export function formatDisplayDate(date) {
  let y = date.getFullYear().toString();
  let m = months[date.getMonth()];
  let n = date.getDate().toString();
  if ( n.length === 1 )
    n = "0" + n;
    
  return n + "-" + m + "-" + y;
}


/**
 * Given a Date object, return short relative date format: 
 * dd Mmm if current year, Mmm yyyy if future years
 * @param {Date} date 
 * @return {string}
 */
export function formatShortDisplayDate(date) {
  let t = new Date();

  let y = date.getFullYear();
  let m = months[date.getMonth()];
  let n = date.getDate().toString();

  if (y === t.getFullYear()) {
    if ( n.length === 1 ) {
      n = "0" + n;
    }

    return n + " " + m;
  }
    
  return m + " " + y.toString();
}

